

export const getIslandsMvList = () => {
  return islandsmvlist.map((island) => ({
    label: island.replace(/_/g, " "), // replace all underscores with spaces
    value: island,
  }));
};

export const islandsmvlist = [
  //Cities
  "MaleCity_Male",
  "MaleCity_Hulhumale",
  "MaleCity_Vilimale",
  "MaleCity_Thilamale",
  "MaleCity_Rasmale",

  // HA (Haa Alif)
  "HA_Dhidhdhoo",
  "HA_Filladhoo",
  "HA_Hoarafushi",
  "HA_Ihavandhoo",
  "HA_Kelaa",
  "HA_Maarandhoo",
  "HA_Molhadhoo",
  "HA_Thakandhoo",
  "HA_Uligamu",

  // HDh (Haa Dhaalu)
  "HDH_Hanimaadhoo",
  "HDH_Hirimaradhoo",
  "HDH_Finey",
  "HDH_Kumundhoo",
  "HDH_Kulhudhuffushi",
  "HDH_Kuribi",
  "HDH_Makunudhoo",
  "HDH_Neykurendhoo",
  "HDH_Nolhivaran",
  "HDH_Nolhivaramfaru",

  // Sh (Shaviyani)
  "SH_Bilehfahi",
  "SH_Feevah",
  "SH_Foakaidhoo",
  "SH_Funadhoo",
  "SH_Goidhoo",
  "SH_Kanditheemu",
  "SH_Komandoo",
  "SH_Lhaimagu",
  "SH_Maaungoodhoo",
  "SH_Maroshi",
  "SH_Narudhoo",
  "SH_Noomaraa",
  "SH_Firubaidhoo",

  // N (Noonu)
  "N_Henbadhoo",
  "N_Holhudhoo",
  "N_Kudafaree",
  "N_Kollafushi",
  "N_Kendhikulhudhoo",
  "N_Maafaru",
  "N_Landhoo",
  "N_Lhohi",
  "N_Manadhoo",
  "N_Velidhoo",

  // R (Raa)
  "R_Alifushi",
  "R_Angolhitheemu",
  "R_Fainu",
  "R_Fasmendhoo",
  "R_Hulhudhuffaaru",
  "R_Innamaadhoo",
  "R_Kadholhudhoo",
  "R_Kinolhas",
  "R_Maakurathu",
  "R_Meedhoo",
  "R_Maduvvari",
  "R_Rasgetheemu",
  "R_Ugoofaaru",

  // B (Baa)
  "B_Eydhafushi",
  "B_Dharavandhoo",
  "B_Goidhoo",
  "B_Hithaadhoo",
  "B_Kendhoo",
  "B_Kihaadhoo",
  "B_Kudarikilu",
  "B_Maalhos",
  "B_Thulhaadhoo",

  // Lh (Lhaviyani)
  "LH_Hinnavaru",
  "LH_Kurendhoo",
  "LH_Naifaru",
  "LH_Olhuvelifushi",

  // K (Kaafu)
  "K_Dhiffushi",
  "K_Gaafaru",
  "K_Gulhi",
  "K_Guraidhoo",
  "K_Himmafushi",
  "K_Huraa",
  "K_Kaashidhoo",
  "K_Maafushi",
  "K_Thulusdhoo",

  // AA (Alif Alif)
  "AA_Bodufolhudhoo",
  "AA_Feridhoo",
  "AA_Maalhos",
  "AA_Mandhoo",
  "AA_Mathiveri",
  "AA_Rasdhoo",
  "AA_Ukulhas",
  "AA_Thoddoo",

  // ADh (Alif Dhaalu)
  "ADH_Dhangethi",
  "ADH_Dhigurah",
  "ADH_Mahibadhoo",
  "ADH_Omadhoo",

  // V (Vaavu)
  "V_Felidhoo",
  "V_Fulidhoo",
  "V_Keyodhoo",
  "V_Thinadhoo",

  // M (Meemu)
  "M_Dhiggaru",
  "M_Kolhufushi",
  "M_Madifushi",
  "M_Maduvvari",
  "M_Mulah",
  "M_Naalaafushi",
  "M_Raimandhoo",
  "M_Veyvah",

  // F (Faafu)
  "F_Bilehdhoo",
  "F_Feeali",
  "F_Magoodhoo",
  "F_Nilandhoo",

  // Dh (Dhaalu)
  "D_Badidhoo",
  "D_Gemendhoo",
  "D_Hulhudheli",
  "D_Kudahuvadhoo",
  "D_Meedhoo",
  "D_Ribudhoo",

  // Th (Thaa)
  "TH_Buruni",
  "TH_Dhiyamigili",
  "TH_Guraidhoo",
  "TH_Madifushi",
  "TH_Thimarafushi",
  "TH_Vandhoo",
  "TH_Vilufushi",

  // L (Laamu)
  "L_Fonadhoo",
  "L_Gaadhoo",
  "L_Gamu",
  "L_Hithadhoo",
  "L_Isdhoo",
  "L_Kalaidhoo",
  "L_Kunahandhoo",
  "L_Maabaidhoo",
  "L_Maamendhoo",
  "L_Maavah",
  "L_Mundoo",

  // GA (Gaafu Alif)
  "GA_Dhaandhoo",
  "GA_Gemanafushi",
  "GA_Kanduhulhudhoo",
  "GA_Kolamaafushi",
  "GA_Maamendhoo",
  "GA_Nilandhoo",
  "GA_Villingili",

  // GDh (Gaafu Dhaalu)
  "GDH_Faresmaathodaa",
  "GDH_Fiyoari",
  "GDH_Hoadedhoo",
  "GDH_Madaveli",
  "GDH_Thinadhoo",

  // Gn (Gnaviyani)
  "GN_Fuvahmulah",

  // S (Seenu / Addu City)
  "S_Feydhoo",
  "S_Hithadhoo",
  "S_Hulhudhoo",
  "S_Maradhoo",
  "S_MaradhooFeydhoo",
  "S_Meedhoo"
];